import { ReactElement } from "react"

import CreateEbDeviceForm from "../../../../components/devices/lct/eb/createEbDeviceForm"
import PublishEbDeviceProvider from "../../../../components/devices/lct/eb/providers/publishEbDeviceProvider"

/** Component to publish a new electric boiler device */
const PublishEbDevice = (): ReactElement => (
    <PublishEbDeviceProvider>
        <CreateEbDeviceForm />
    </PublishEbDeviceProvider>
)

export default PublishEbDevice
